import React from 'react';
import DashboardUsersTable from '../../company/components/DashboardUsersTable';
import PrivatePageHOC from '../../containers/PrivatPageHOC/PrivatePageHOC';

const DashboardUsersContainer = () => <DashboardUsersTable type="adminUserList" />;

export default PrivatePageHOC(DashboardUsersContainer);
